import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiChevronRight, FiCompass, FiFeather, FiTool, FiStar, FiUsers, FiAward, FiZap, FiCheck, FiHeart } from 'react-icons/fi';
import '../../styles/categoryPage.css';
import './About.css';

const About = () => {
  const sections = [
    {
      Icon: FiCompass,
      title: 'Notre Mission',
      text: "Nous croyons en notre créativité dans la création des meubles. Notre objectif est créer des meubles innovants à travers l'art. Chaque création que nous réalisons est imprégnée de cette passion et de cet engagement envers l'excellence.",
    },
    {
      Icon: FiFeather,
      title: 'Approche Créative',
      text: 'Dans notre atelier, l\'innovation et la qualité sont nos maîtres-mots. Nous mettons en lumière les bureaux, tables de réunion, rangements, accessoires de bureau, cuisine, dressing, habillage mural, fourniture en bois, chaises directeurs et chaises bureau.',
    },
    {
      Icon: FiTool,
      title: 'Ce que Nous Faisons',
      text: 'Que ce soit des bureaux sur mesure pour améliorer votre espace de travail, des meubles qui deviennent le cœur de votre foyer, ou des éléments de cuisine qui conjuguent praticité et esthétique, nous excellons dans fabrication des meubles.',
    },
    {
      Icon: FiStar,
      title: 'Notre Engagement',
      text: 'Chez HOME DECO, nous nous engageons à déterminer les demandes client avec perfectionnisme. Chaque interaction avec nous est une occasion de vous offrir une expérience exceptionnelle.',
    },
    {
      Icon: FiUsers,
      title: 'Rejoignez Notre Communauté',
      text: 'Connectons-nous ! Suivez-nous pour être inspiré(e) par nos dernières créations, participer à des événements exclusifs et faire partie d\'une communauté qui partage votre passion pour la création des meubles.',
    },
  ];

  const values = [
    { icon: <FiAward />, title: 'Créativité', desc: 'Designs uniques et innovants' },
    { icon: <FiCheck />, title: 'Qualité', desc: 'Matériaux premium et finition impeccable' },
    { icon: <FiHeart />, title: 'Passion', desc: 'Amour du métier dans chaque détail' },
    { icon: <FiZap />, title: 'Innovation', desc: 'Solutions techniques avant-gardistes' },
  ];

  return (
    <section className="hd-about-section">
      <div className="container">
        <motion.nav
          className="hd-breadcrumb"
          aria-label="breadcrumb"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4 }}
        >
          <Link to="/">Accueil</Link>
          <FiChevronRight />
          <span>À propos</span>
        </motion.nav>
      </div>

      <div className="hd-about-hero">
        <motion.div
          className="hd-about-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="hd-about-eyebrow">Notre histoire</span>
          <h1 className="hd-about-hero-title">
            Home <em>Deco</em>
          </h1>
          <p className="hd-about-hero-subtitle">L'art du mobilier métallique</p>
          <p className="hd-about-hero-description">
            Créateurs d'espaces uniques où l'élégance du métal rencontre
            l'innovation design pour transformer vos intérieurs.
          </p>
        </motion.div>
      </div>

      <div className="container">
        <motion.div
          className="hd-about-content"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
          transition={{ staggerChildren: 0.12 }}
          variants={{ hidden: {}, visible: {} }}
        >
          {sections.map((section, i) => (
            <motion.div
              key={i}
              className="hd-about-card"
              variants={{
                hidden: { opacity: 0, y: 24 },
                visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
              }}
              whileHover={{ y: -6 }}
            >
              <div className="hd-about-icon">
                <section.Icon />
              </div>
              <div className="hd-about-card-content">
                <h3>{section.title}</h3>
                <p>{section.text}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="hd-about-values"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <span className="hd-about-eyebrow">Ce qui nous anime</span>
          <h2>Nos Valeurs Fondamentales</h2>
          <div className="hd-about-values-grid">
            {values.map((value, i) => (
              <motion.div
                key={i}
                className="hd-about-value-card"
                whileHover={{ y: -4 }}
              >
                <div className="hd-about-value-icon-container">{value.icon}</div>
                <h4>{value.title}</h4>
                <p>{value.desc}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
